export default function filterBlocksByLocation(blocks, location) {
    if (!blocks || !location) {
        return [];
    }

    // Sometimes block.attrs is an empty array if there are no values, so have to include optional chaining here
    return blocks.filter(block => block?.attrs?.blockLocation === location);
}
